import React, { Component, lazy, Suspense } from "react";
import { Link, Switch, Route, Redirect } from "react-router-dom";
import { Container } from "reactstrap";
import store from "store";

import "react-select/dist/react-select.css";

import Header from "@components/Header/";
import Sidebar from "@components/Sidebar/";
import Breadcrumb from "@components/Breadcrumb/";
import Aside from "@components/Aside/";
import Footer from "@components/Footer/";
//const Homepage = lazy(() => import("@views/Homepage"));
const HomepageNew = lazy(() => import("@views/HomepageNew"));
const Tutorials = lazy(() => import("@views/Tutorials"));
const Dashboard = lazy(() => import("@views/Dashboard/"));
//const MyContent = lazy(() => import("@views/Latest/MyContent"));
const ItemDetail = lazy(() => import("@views/Latest/ItemDetail/"));
const Unmatched = lazy(() => import("@views/Unmatched/"));

const SearchRegulatorNotices = lazy(() => import("@views/RegulatorNotices/Search"));
const EditCreateRegulatorNotices = lazy(() => import("@views/RegulatorNotices/EditCreate"));

const FiltersManage = lazy(() => import("@views/Filters/FiltersManage"));
const FiltersEditSave = lazy(() => import("@views/Filters/FiltersEditSave"));

const ServiceLinesMapping = lazy(() => import("@views/ServiceLinesMapping"));
const RegulatoryCategoriesMapping = lazy(() => import("@views/RegulatoryCategoriesMapping"));

// const Notifications = lazy(() => import("@views/DocumentWorkflow/Notifications"));
const DocumentDetails = lazy(() => import("@views/DocumentWorkflow/DocumentDetails"));

const AutoAssignEdit = lazy(() => import("@views/DocumentWorkflow/AutoAssign"));
const EscalationEdit = lazy(() => import("@views/DocumentWorkflow/Escalation"));

const WorkflowsList = lazy(() => import("@views/Workflows/WorkflowsList"));
const WorkflowEdit = lazy(() => import("@views/Workflows/WorkflowEdit"));

const AlertingList = lazy(() => import("@views/Alerting/AlertingList"));
const AlertingCreateUpdate = lazy(() => import("@views/Alerting/AlertingCreateUpdate"));

const Preferences = lazy(() => import("@views/Preferences/Preferences"));
const RiskFusion = lazy(() => import("@views/Pages/RiskFusion/RiskFusion"));
const RegulatoryRiskAnalysis = lazy(() => import("@views/Reports/RegulatoryRiskAnalysis"));

const MyReviews = lazy(() => import("@views/Cases/MyReviews"));
const MyCases = lazy(() => import("@views/Cases/MyCases/MyCases"));
const ClientReviews = lazy(() => import("@views/Cases/ClientReviews"));
const ClientCases = lazy(() => import("@views/Cases/ClientCases/ClientCases"));
const EditCase = lazy(() => import("@views/Cases/EditCase"));
const CreateUpdateCase = lazy(() => import('@views/Cases/CreateUpdateCase'));

const CreateCase = lazy(() => import("@views/Cases/CreateCase"));
const UpdatedBusinessMap = lazy(() => import("@views/Cases/UpdatedBusinessMap"));

const MarketingNoticesList = lazy(() => import("@views/MarketingNotices/MarketingNoticesList"));
const CreateMarketingNotice = lazy(() => import("@views/MarketingNotices/CreateMarketingNotice"));
const Notifications = lazy(() => import("@views/Notifications"));

// const AdvancedSearchCore = lazy(() => import("@views/AdvancedSearch/AdvancedSearchCore/AdvancedSearchCore"));
const SearchManager = lazy(() => import('../../views/SearchManager'));
const RegulatorBookBooks = lazy(() => import("@views/RegulatorBooks/Books/RegulatoryBookBooks"));
const RegulatorBookChapters = lazy(() => import("@views/RegulatorBooks/Chapters/RegulatoryBookChapters"));
const RegulatoryChapterBlocks = lazy(() => import("@views/RegulatorBooks/Blocks/RegulatoryBlocks"));

const RegulationList = lazy(() => import("@views/Regulation/RegulationList"));
// const Regulation = lazy(() => import("@views/Regulation"));
const RegulationSearch = lazy(() => import("@views/RegulationNew/RegulationSearch"));
const RegulationContent = lazy(() => import("@views/RegulationNew/RegulationContent"));

const BusinessImpactMap = lazy(() => import("@views/RegulatorBooks/BusinessImpactMap"));
const DisambiguatedText = lazy(() => import("@views/RegulatorBooks/DisambiguatedText"));

const ControlledJobFunctions = lazy(() => import("@views/ControlledJobFunctions"));

const StrategicRisk = lazy(() => import("@views/StrategicRisk"));
const ServiceLineSearchCore = lazy(() => import("@views/ServiceLineAutotag/ServiceLineSearchCore/ServiceLineSearchCore"));
const ServiceLineAutoTagList = lazy(() => import("@views/ServiceLineAutotag/ServiceLineAutoTagList/ServiceLineAutoTagList"));

const Details = lazy(() => import("@views/TaxonomyMapping/Details"));
const Documents = lazy(() => import("@views/TaxonomyMapping/Documents"));
const CategoryStructure = lazy(() => import("@views/TaxonomyMapping/CategoryStructure"));
const CategoryMapping = lazy(() => import("@views/TaxonomyMapping/CategoryMapping"));
const ServiceLineStructure = lazy(() => import("@views/TaxonomyMapping/ServiceLineStructure"));
const ServiceLineMapping = lazy(() => import("@views/TaxonomyMapping/ServiceLineMapping"));
const MapUsers = lazy(() => import("@views/TaxonomyMapping/MapUsers"));
const TaxonomyMapping = lazy(() => import("@views/TaxonomyMapping"));
const ModelsList = lazy(() => import("@views/Models/ModelsList"));
const ModelsCreateUpdate = lazy(() => import("@views/Models/ModelsCreateUpdate"));

const ModelDetails = lazy(() => import("@views/Models/ModelDetails"));

const FineDetails = lazy(() => import("@views/FineDetails"));

const RegulationProfiler = lazy(() => import("@views/RegulationProfiler"));
const ControlsExplorer = lazy(() => import("@views/ControlsExplorer"));
const Covid = lazy(() => import("@views/Covid"));

const ManageLossReport = lazy(() => import("@views/LossReports/ManageLossReport"));

const RegulationTagsList = lazy(() => import("@views/RegulationTags/RegulationTagsList"));
const RegulationTagDetails = lazy(() => import("@views/RegulationTags/RegulationTagDetails"));

const LossReportList = lazy(() => import("@views/LossReports/LossReportList"));

import HelpForm from "@components/HelpForm";

const HeatMap = lazy(() => import("@views/HeatMap"));
const FinesList = lazy(() => import("@views/FinesList"));

const RegulatoryExplorer = lazy(() => import("@views/RegulatoryExplorer"));
const RedirectionToDetails = lazy(() => import("@components/RedirectionToDetails"));

const ThemesList = lazy(() => import("@views/Themes/ThemesList"));
const ThemeUpdate = lazy(() => import("@views/Themes/ThemeUpdate"));

const ClientTaxonomiesList = lazy(() => import("@views/ClientTaxonomies/ClientTaxonomiesList"));
const ClientTaxonomyTerms = lazy(() => import("@views/ClientTaxonomies/ClientTaxonomyTerms"));

const RegulationTaggingList = lazy(() => import("@views/RegulationTaggingTool/RegulationsList"));
const RegulationTagging = lazy(() => import("@views/RegulationTaggingTool/RegulationTagging"));
const FinraVisualisation = lazy(() => import("@views/FinraVisualisation"));
const FinraVisualisationDetails = lazy(() => import("@views/FinraVisualisation/FinraVisualisationDetails"));

const DashboardConfig = lazy(() => import("@views/ThemesDashboard/Configuration/DashboardConfig"));
const DashboardList = lazy(() => import("@views/ThemesDashboard/SelectionScreen/DashboardList"));


const WatchListSingle = lazy(() => import("@views/WatchList/WatchListSingle"));

import { ApplicationInsights } from "@microsoft/applicationinsights-web";
import { ReactPlugin, withAITracking } from "@microsoft/applicationinsights-react-js";
import { appInsightKey } from "Config";
import history from "../../services/AIservice/AIservice";

const ApiViewerAuthorities = lazy(() => import('../../views/ApiViewer/ApiViewerAuthorities'));
const ApiViewerRegulations = lazy(() => import('../../views/ApiViewer/ApiViewerRegulations'));
const ApiViewerVersions = lazy(() => import('../../views/ApiViewer/ApiViewerVersions'));
const ApiViewerContent = lazy(() => import('../../views/ApiViewer/ApiViewerContent'));

const UserRoutingList = lazy(() => import('../../views/UserRouting/UserRoutingList'));
const UserRoutingRules = lazy(() => import('../../views/UserRouting/UserRoutingRules'));
const UserRoutingDetails = lazy(() => import('../../views/UserRouting/UserRoutingDetails'));

const TestDashboard = lazy(() => import("@components/DashboardTemplates/TestDashboard"));
const AutoTasksList = lazy(() => import("@views/AutoTasks/AutoTasksList"));
const AutoTasksForm = lazy(() => import("@views/AutoTasks/AutoTasksForm"));

const LegalEntityList = lazy(() => import("@views/LegalEntities/LegalEntityList"));
const MyQueue = lazy(() => import("@views/MyQueue/MyQueue"));
const ESGTracker = lazy(() => import("@views/ESGTracker"));
const FinCrimeTracker = lazy(() => import("@views/FinCrimeTracker"));

const UserGroupsList = lazy(() => import("@views/UserGroups/UserGroupsList"));
const UserGroupsUpdate = lazy(() => import("@views/UserGroups/UserGroupsUpdate"));
const UserGroupsCreate = lazy(() => import("@views/UserGroups/UserGroupsCreate"));

const PushApi = lazy(() => import("@views/PushApi/PushApiDashboard"));
const PushApiDetails = lazy(() => import("@views/PushApi/PushApiDetails"));

const RegulationAssessments = lazy(() => import('@views/RegulationAssessments/RegulationAssessments'));
const AllObligations = lazy(() => import('@views/AllObligations'));

const Controls = lazy(() => import('@views/Controls'))
const Procedures = lazy(() => import('@views/Procedures'));

const ProceduresWatchlist = lazy(() => import('@views/ProceduresWatchlist'));

let reactPlugin = null;
let appInsights = null;

if (appInsightKey) {
  reactPlugin = new ReactPlugin();
  appInsights = new ApplicationInsights({
    config: {
      instrumentationKey: appInsightKey,
      extensions: [reactPlugin],
      extensionConfig: {
        [reactPlugin.identifier]: { history: history },
      },
    },
  });
  appInsights.loadAppInsights();
}

class Full extends Component {
  constructor(props) {
    super(props);

    this.state = { openHelpForm: false };
    this.apiLoginType = store.get("CorlyticsApiLogin");
    this.openHelpForm = this.openHelpForm.bind(this);
    this.closeHelpForm = this.closeHelpForm.bind(this);
  }

  UNSAFE_componentWillMount() {
    if (appInsightKey) {
      this.unlisten = this.props.history.listen((location, action) => {
        appInsights.addTelemetryInitializer((envelope) => {
          envelope.tags["ai.operation.name"] = location.pathname;
        });
      });
    }
  }

  UNSAFE_componentWillUnmount() {
    if (appInsightKey) this.unlisten();
  }

  openHelpForm() {
    this.setState({ openHelpForm: true });
  }
  closeHelpForm() {
    this.setState({ openHelpForm: false });
  }

  render() {
    return (
      <div className="app">
        {this.apiLoginType && (
          <div className="deloitte-bar">
            <img src="img/deloitte.png" alt="Deloitte" style={{ height: "35px", marginRight: "10px" }} />
            <img src="img/proact.png" alt="Proact" style={{ height: "40px" }} />
          </div>
        )}
        <Sidebar {...this.props} />
        <div className={"app-body" + (this.apiLoginType ? " ext-login" : "")}>
          <main className="main">
            <Header history={this.props.history} external={this.apiLoginType} help={this.openHelpForm} />
            <Breadcrumb />
            <Container fluid>
              <Suspense fallback={<div className="animated fadeIn wrapper"><div className="card"><div className="card-body" style={{ minHeight: '200px' }}>Loading...</div></div></div>} >
                <Switch>

                  <Route path="/home" name="My Dashboard" component={HomepageNew} />
                  <Route path="/tutorials" name="Tutorials" component={Tutorials} />
                  <Route path="/dashboard" name="Dashboard" component={Dashboard} />
                  <Route path="/latest/detail" name="Item Detail" component={ItemDetail} />

                  <Route path="/RegulatoryExplorer/DocumentDetails" name="Item Detail Doc" component={RedirectionToDetails} />
                  <Route path="/RegulatoryExplorer/EnforcementDetails" name="Item Detail Enf" component={RedirectionToDetails} />

                  <Route path="/RegulatoryExplorer/DocumentDetails" name="Item Detail Doc" component={ItemDetail} />
                  <Route path="/RegulatoryExplorer/EnforcementDetails" name="Item Detail Enf" component={ItemDetail} />
                  {/* <Route path="/latest" name="Latest Feeds" component={MyContent} /> */}
                  <Route path="/unmatched" name="Unmatched Enforcements" component={Unmatched} />

                  {/* <Route path="/notifications" name="Notifications" component={Notifications} />
                  <Route path="/document-details" name="Document Details" component={DocumentDetails} /> */}

                  <Route path="/wfsetup/auto-assign/create" name="Create Auto-Assignment" component={AutoAssignEdit} />
                  <Route path="/wfsetup/escalation/create" name="Create Escalation Rule" component={EscalationEdit} />

                  <Route path="/service-lines-mapping" name="Service Lines Mapping" component={ServiceLinesMapping} />
                  <Route path="/regulatory-categories-mapping" name="Regulatory Categories Mapping" component={RegulatoryCategoriesMapping} />

                  <Route path="/search-manage" name="Manage Saved Searches" component={FiltersManage} />
                  <Route path="/filters-edit" name="Edit Filter" component={FiltersEditSave} />
                  <Route path="/filters-create" name="Create Filter" component={FiltersEditSave} />

                  <Route path="/workflows/edit" name="WorkflowEdit" component={WorkflowEdit} />
                  <Route path="/workflows" name="Workflows" component={WorkflowsList} />

                  <Route path="/regulator-notices/search" name="SearchRegulatorNotices" component={SearchRegulatorNotices} />
                  <Route path="/regulator-notices/edit" name="EditRegulatorNotices" component={EditCreateRegulatorNotices} />
                  <Route path="/regulator-notices/create" name="CreateRegulatorNotices" component={EditCreateRegulatorNotices} />

                  <Route path="/regulations-list/:code?" name="RegulationList" component={RegulationList} />

                  <Route exact path="/regulation" name="Regulation" component={RegulationSearch} />
                  {/* <Route exact path="/regulation-new" name="RegulationSearch" component={RegulationSearch} /> */}
                  <Route path="/regulation/:id/updates" name="RegulationContent" component={RegulationContent} />
                  <Route path="/regulation/:id/version/:versionId/updates" name="RegulationContent" component={RegulationContent} />
                  <Route path="/regulation/:id/version/:versionId" name="RegulationContent" component={RegulationContent} />
                  <Route path="/regulation/:id/content/:contentId/version/:versionId/tags" name="RegulationContent" component={RegulationContent} />
                  <Route path="/regulation/:id/content/:contentId/version/:versionId" name="RegulationContent" component={RegulationContent} />
                  <Route path="/regulation/:id/content/:contentId" name="RegulationContent" component={RegulationContent} />
                  <Route path="/regulation/:id/content" name="RegulationContent" component={RegulationContent} />

                  <Route path="/regulation-books/:regulatorId/" name="RegulatorBookBooks" component={RegulatorBookBooks} />
                  <Route path="/books/:bookId/sections" name="RegulatorBookChapters" component={RegulatorBookChapters} />
                  <Route path="/chapters/:chapterId" name="RegulatorChapterBlocks" component={RegulatoryChapterBlocks} />

                  <Route path="/business-impact-map" name="BusinessImpactMap" component={BusinessImpactMap} />
                  <Route path="/disambiguated-text" name="DisambiguatedText" component={DisambiguatedText} />

                  <Route path="/alerting" name="Alerts" component={AlertingList} />
                  <Route path="/alerting-create/:from_search?" name="AlertingCreate" component={AlertingCreateUpdate} />
                  <Route path="/alerting-edit" name="AlertingEdit" component={AlertingCreateUpdate} />

                  <Route path="/preferences" name="Preferences" component={Preferences} />
                  <Route path="/riskfusion" name="RiskFusion" component={RiskFusion} />
                  <Route path="/regulator-report" name="RegulatorReport" component={RegulatoryRiskAnalysis} />

                  <Route path="/tasks/list" name="MyReviews" component={MyReviews} />
                  <Route path="/assessments/list" name="MyCases" component={MyCases} />

                  <Route path="/all-tasks/list" name="ClientReviews" component={ClientReviews} />
                  <Route path="/all-assessments/list" name="ClientCases" component={ClientCases} />

                  <Route path="/assessments/new" name="NewCase" component={CreateCase} />
                  <Route path="/assessments/edit/:id" name="CreateUpdateCase" component={CreateUpdateCase} />
                  <Route path="/assessments/business-map/:id" name="CaseBusinessMap" component={UpdatedBusinessMap} />

                  <Route path="/marketing-notices/list" name="MarketingNotices" component={MarketingNoticesList} />
                  <Route path="/marketing-notices/edit" name="EditMarketingNotices" component={CreateMarketingNotice} />

                  <Route path="/corlytics-updates" name="Corlytics Updates" component={Notifications} />

                  <Route path="/search" name="Search" component={SearchManager} />
                  {/* <Route path="/search-manager" name="AdvancedSearch" component={AdvancedSearchCore} /> */}

                  <Route path="/sl-autotags" name="ServiceLineSearchList" component={ServiceLineAutoTagList} />
                  <Route path="/sl-autotag/create/:search_id?" name="ServiceLineSearch" component={ServiceLineSearchCore} />

                  <Route path="/controlled-job-functions" name="ControlledJobFunctions" component={ControlledJobFunctions} />

                  {/* <Route path="/models/update/:id?" name="ModelsUpdate" component={ModelsCreateUpdate} />
                <Route path="/models/create" name="ModelsCreate" component={ModelsCreateUpdate} /> */}


                  <Route path="/models/update/:id?" name="ModelsNewUpdate" component={ModelDetails} />
                  <Route path="/models/create" name="ModelsNewCreate" component={ModelDetails} />
                  <Route path="/models" name="Models" component={ModelsList} />

                  <Route path="/risk-outlook/:id?" name="StrategicRisk" component={StrategicRisk} />
                  <Route path="/regulation-profiler" name="RegulationProfiler" component={RegulationProfiler} />

                  <Route path="/taxonomy-mapping/details/:client/:id?" name="TaxonomyDetails" component={Details} />
                  <Route path="/taxonomy-mapping/documents/:client/:id" name="TaxonomyDocuments" component={Documents} />
                  <Route path="/taxonomy-mapping/category-structure/:client/:id" name="CategoryStructure" component={CategoryStructure} />
                  <Route path="/taxonomy-mapping/category-mapping/:client/:id" name="CategoryMapping" component={CategoryMapping} />
                  <Route path="/taxonomy-mapping/service-line-structure/:client/:id" name="ServiceLineStructure" component={ServiceLineStructure} />
                  <Route path="/taxonomy-mapping/service-line-mapping/:client/:id" name="ServiceLineMapping" component={ServiceLineMapping} />
                  <Route path="/taxonomy-mapping/users/:client/:id" name="MapUsers" component={MapUsers} />
                  <Route path="/taxonomy-mapping/:client?" name="TaxonomyMapping" component={TaxonomyMapping} />

                  <Route path="/controls-analysis" name="ControlsAnalysis" component={ControlsExplorer} />
                  <Route path="/regulatory-analysis" name="RegulatoryAnalysis" component={RegulatoryExplorer} />
                  <Route path="/covid" name="Covid" component={Covid} />
                  <Route path="/procedures" name="Procedures" component={Procedures} />
                  <Route path="/controls" name="Controls" component={Controls} />

                  <Route path="/loss-report" name="LossReport" component={ManageLossReport} />
                  <Route path="/loss-report-list" name="Reports" component={LossReportList} />

                  <Route path="/rri" name="HeatMap" component={HeatMap} />
                  <Route path="/fines-list" name="FinesList" component={FinesList} />
                  <Route path="/fine-details" name="FineDetails" component={FineDetails} />

                  <Route path="/themes" name="ThemesList" component={ThemesList} />
                  <Route path="/theme/:id" name="ThemeUpdate" component={ThemeUpdate} />

                  <Route path="/client-taxonomies" name="ClientTaxonomysList" component={ClientTaxonomiesList} />
                  <Route path="/client-taxonomy/:id/:title" name="ClientTaxonomyTerms" component={ClientTaxonomyTerms} />

                  <Route path="/finra-rules/:id" name="RegulationTaggingScreen" component={RegulationTagging} />
                  <Route path="/finra-rules" name="RegulationTaggingList" component={RegulationTaggingList} />
                  <Route path="/finra-visualisation/:id" name="VisualisationDetails" component={FinraVisualisationDetails} />
                  <Route path="/finra-visualisation" name="VisualisationFilters" component={FinraVisualisation} />

                  <Route path="/watchlist" name="WatchListSingle" component={WatchListSingle} />

                  <Route path="/theme-dashboard-config" name="ThemeDashboardConfig" component={DashboardConfig} />
                  <Route path="/dashboards/list" name="DashboardList" component={DashboardList} />

                  <Route path="/api-viewer/authorities" name="API Viewer Authorities" component={ApiViewerAuthorities} />
                  <Route path="/api-viewer/regulations/:id/:title" name="API Viewer Regulations" component={ApiViewerRegulations} />
                  <Route path="/api-viewer/versions/:id/:title" name="API Viewer Versions" component={ApiViewerVersions} />
                  <Route path="/api-viewer/content/:id" name="API Viewer Content" component={ApiViewerContent} />

                  <Route path="/workflow-routing/:id" name="UserRoutingDetails" component={UserRoutingDetails} />
                  <Route path="/workflow-routing" name="UserRouting" component={UserRoutingList} />

                  <Route path="/auto-tasks/:id" name="AutoTasksCreate" component={AutoTasksForm} />
                  <Route path="/auto-tasks" name="AutoTasks" component={AutoTasksList} />

                  <Route path="/user-groups/update/:id" name="UserGroupsUpdate" component={UserGroupsUpdate} />
                  <Route path="/user-groups/create" name="UserGroupsCreate" component={UserGroupsCreate} />
                  <Route path="/user-groups" name="UserGroups" component={UserGroupsList} />

                  <Route path="/legal-entities" name="LegalEntities" component={LegalEntityList} />
                  <Route path="/queues" name="MyQueue" component={MyQueue} />

                  <Route path="/esg-tracker" name="ESGTracker" component={ESGTracker} />
                  <Route path="/fincrime-tracker" name="FinCrimeTracker" component={FinCrimeTracker} />

                  <Route path="/push-api/:id" name="PushApi" component={PushApiDetails} />
                  <Route path="/push-api" name="PushApi" component={PushApi} />

                  <Route path="/reg-access-group/:id" name="RegulationTagDetails" component={RegulationTagDetails} />
                  <Route path="/reg-access-group" name="RegulationTags" component={RegulationTagsList} />

                  <Route path="/test-dashboard" name="TestDashboard" component={TestDashboard} />

                  <Route path="/regulation-tags/:id" name="RegulationTagDetails" component={RegulationTagDetails} />
                  <Route path="/regulation-tags" name="RegulationTags" component={RegulationTagsList} />

                  <Route path="/procedures-watchlist" name="ProceduresWatchlist" component={ProceduresWatchlist} />

                </Switch>
              </Suspense>
            </Container>
          </main>
          <Aside />
        </div>
        <Footer />
        <HelpForm open={this.state.openHelpForm} close={this.closeHelpForm} />
      </div>
    );
  }
}

export default appInsightKey ? withAITracking(reactPlugin, Full) : Full;



// WEBPACK FOOTER //
// ./src/containers/Full/Full.js